<div class="searchdiv">
    <div class="card screen-wrapper">
        <div class="header headerdiv">
            <h1 class="screen-title">{{ screentitle }}</h1>
        </div>

        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-div">
                        <div class="row">
                            <div>
                                <div style="padding: 2% 4% 2% 2%">
                                    <div class="wr15">
                                        <div>
                                            <div class="instruct">
                                                <div class="int1" style="margin-left: 17px">
                                                    <span class="inst" style="font-size: 12px"><strong> Instructions
                                                        </strong></span>
                                                    <br />
                                                    <span class="txt">
                                                        1. Select values: Origin, Destination, Onward and/Or Return
                                                        date, Adult, Child, Infant and Cabin class.
                                                    </span>
                                                    <br />
                                                    <span class="txt">
                                                        2. Prices are shown in INR.
                                                    </span>
                                                    <br />
                                                    <span></span>
                                                </div>
                                            </div>

                                            <div class="col-md-3">

                                                <label>Origin</label>
                                                <input type="text" class="form-control m-input"
                                                    [(ngModel)]="search_details.originCode" maxlength="3" required
                                                    (input)="checkCityValidation($event.target.value, 'originCity')"
                                                    placeholder="Enter Origin Code" style="text-transform: uppercase">

                                                <span id="whereFromErr" style="color: red"></span>
                                            </div>

                                            <div class="col-md-3">

                                                <label class="">Destination</label>
                                                <input type="text" class="form-control m-input"
                                                    [(ngModel)]="search_details.destinationCode" maxlength="3" required
                                                    (input)="checkCityValidation($event.target.value, 'destinationCity')"
                                                    placeholder="Enter Destination Code"
                                                    style="text-transform: uppercase">

                                                <span id="whereToErr" style="color: red"></span>
                                            </div>


                                            <div class="col-md-3" style="margin-top: 19px">
                                                <mat-form-field>
                                                    <input id="did" #fromDate matInput
                                                        [(ngModel)]="search_details.bookingdate_from"
                                                        [matDatepicker]="pickerFrom"
                                                        (dateChange)="disableToBookingField()" autocomplete="off"
                                                        placeholder="Onward Date" [min]="search_minFromDate" readonly />
                                                    <mat-datepicker-toggle matSuffix [for]="pickerFrom">
                                                    </mat-datepicker-toggle>
                                                    <mat-datepicker #pickerFrom></mat-datepicker>
                                                </mat-form-field>

                                                <button type="button" class="close opa"
                                                    (click)="reset('fromBookingDate')" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <br>

                                            </div>

                                            <div class="col-md-3" style="margin-top: 19px">

                                                <mat-form-field>
                                                    <input #toDate matInput [(ngModel)]="search_details.bookingdate_to"
                                                        [matDatepicker]="pickerTo" autocomplete="off"
                                                        (dateChange)="validate()" [min]="search_minTodate"
                                                        placeholder="Return Date" readonly />
                                                    <mat-datepicker-toggle matSuffix [for]="pickerTo">
                                                    </mat-datepicker-toggle>
                                                    <mat-datepicker #pickerTo></mat-datepicker>
                                                </mat-form-field>
                                                <button style="margin-left: 5px;" type="button" class="close opa"
                                                    (click)="reset('toBookingDate')" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                                <br>
                                            </div>
                                            <div class="clr"></div>
                                            <div class="divider"></div>
                                            <div class="col-md-3">
                                                <label class="">Adult</label>
                                                <select (change)="fixInfantAndChildOptions()"
                                                    class="form-control m-input" [(ngModel)]="search_details.noOfAdult">
                                                    <option value="E" disabled>Select No. of Adult</option>
                                                    <option value="1">1</option>

                                                    <option *ngFor="let item of adult_list" value="{{ item.key }}">{{
                                                        item.value }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="">Child</label>
                                                <select (change)="toggleSearchButton()" class="form-control m-input"
                                                    [(ngModel)]="search_details.noOfChild">
                                                    <option value="E" disabled>Select No. of Child</option>
                                                    <option value="0">0</option>

                                                    <option *ngFor="let item of child_list" value="{{ item.key }}">{{
                                                        item.value }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="">Infant</label>
                                                <select (change)="toggleSearchButton()" class="form-control m-input"
                                                    [(ngModel)]="search_details.noOfInfant">
                                                    <option value="E" disabled>Select No. of Infant</option>
                                                    <option value="0">0</option>

                                                    <option *ngFor="let item of infant_list" value="{{ item.key }}">{{
                                                        item.value }}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="">Cabin Class</label>
                                                <select (change)="toggleSearchButton()" class="form-control m-input"
                                                    [(ngModel)]="search_details.class">
                                                    <option value="E" disabled>Select</option>
                                                    <option value="1">Economy</option>

                                                    <option *ngFor="let item of cabin_class" value="{{ item.key }}">{{
                                                        item.value }}
                                                    </option>
                                                </select>
                                            </div>



                                        </div>
                                    </div>
                                </div>
                                <div class="clr"></div>
                                <div class="wr15">
                                    <div class="sdiv">
                                        <div class="btn clear-button button-margin">
                                            <button class="btn btn-primary  commonbutt" (click)="searchData()"
                                                [disabled]="isSearchBtnDisable" type="button">
                                                <em class="fa fa-search "></em>&nbsp;Search
                                            </button>
                                            <button class="btn btn-primary commonbutt" type="button"
                                                [disabled]="isSearchBtnDisable || isDownloadBtnDisable"
                                                (click)="downloadData()">
                                                Download
                                            </button>
                                            <button class="btn btn-primary commonbutt" type="button"
                                                [disabled]="isSearchBtnDisable" (click)="downloadResponseData()">
                                                Download Response
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="clr"></div>
                                <div *ngIf="isSearchDataNotAvailable" style="margin-top: 20px;" class="errdiv1">
                                    <h1 style="text-align:center" id="noresulrErr">
                                        {{searchResultMessage}}
                                    </h1>
                                </div>
                                <div *ngIf="loader">
                                    <div style="margin: 0 auto; text-align: center;">
                                        <img src="../../../assets/img/Loading_Animation.gif" width="4%" height="4%"
                                            alt="Loader" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="clr"></div>
        <div style="margin-top: 50px; margin-left: 10px; margin-right: 10px;" *ngIf="tableData.length > 0">
            <app-simple-table [isFilterAvailable]="isFilterAvailable" [tableColumnsData]="tableColumnsData"
                [tableData]="tableData"></app-simple-table>
        </div>

    </div>
</div>